// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"LandingPage_imageContainer__2gQ4z","videoCover":"LandingPage_videoCover__QYEtN"};